import React from "react";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Button = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "secondary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, onClick = _a.onClick, icon = _a.icon, _f = _a.iconPosition, iconPosition = _f === void 0 ? "left" : _f, _g = _a.type, type = _g === void 0 ? "button" : _g, _h = _a.className, className = _h === void 0 ? "" : _h, style = _a.style, title = _a.title, ariaLabel = _a.ariaLabel, _j = _a.fullWidth, fullWidth = _j === void 0 ? false : _j;
    var baseClasses = "lib-button";
    var variantClass = "lib-button-".concat(variant);
    var sizeClass = "lib-button-".concat(size);
    var disabledClass = disabled || loading ? "lib-button-disabled" : "";
    var loadingClass = loading ? "lib-button-loading" : "";
    var fullWidthClass = fullWidth ? "lib-button-full-width" : "";
    var iconClass = icon || loading ? "lib-button-with-icon lib-button-icon-".concat(iconPosition) : "";
    var allClasses = [
        baseClasses,
        variantClass,
        sizeClass,
        disabledClass,
        loadingClass,
        fullWidthClass,
        iconClass,
        className,
    ]
        .filter(Boolean)
        .join(" ");
    var handleClick = function (event) {
        if (!disabled && !loading && onClick) {
            onClick(event);
        }
    };
    var displayIcon = loading ? faSpinner : icon;
    var iconSpin = loading;
    return (React.createElement("button", { type: type, className: allClasses, onClick: handleClick, disabled: disabled || loading, style: style, title: title, "aria-label": ariaLabel },
        displayIcon && iconPosition === "left" && (React.createElement(FontAwesomeIcon, { icon: displayIcon, className: "lib-button-icon", spin: iconSpin })),
        children,
        displayIcon && iconPosition === "right" && (React.createElement(FontAwesomeIcon, { icon: displayIcon, className: "lib-button-icon", spin: iconSpin }))));
};
export default Button;
